import { yupResolver } from "@hookform/resolvers/yup";
import { useFetchUser } from "@sushicorp/services";
import { DocumentType } from "artisn/types";
import React, { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";

import Styles from "./BillingFormModal.styles";
import { BillingFormModalProps as Props } from "./BillingFormModal.types";
import BillingDataForm from "../BillingDataForm/BillingDataForm";
import { getBillingDataFormSchema } from "../BillingDataForm/BillingDataForm.helpers";
import Modal from "components/global/Modal/Modal";
import useAuth from "contexts/auth/auth.context.hooks";
import { notify } from "utils/common.utils";

const BillingFormModal: React.FC<Props> = props => {
  const { onClose } = props;
  const [documentType, setDocumentType] = useState<DocumentType>();
  const auth = useAuth();
  const { data: user } = useFetchUser(auth, notify);
  const { document } = user ?? {};
  const { documentType: documentTypeUser } = user ?? {};

  const billingFormMethods = useForm({
    mode: "onChange",
    resolver: yupResolver(getBillingDataFormSchema(documentType)),
    defaultValues: {
      name: "",
      lastname: "",
      email: "",
      phone: "",
      documentType: documentTypeUser ?? "",
      document: document ?? "",
      default: true,
      externalId: null
    }
  });

  return (
    <Modal {...props} closeOnClickOutside={false}>
      <Styles className="BillingFormModal">
        <FormProvider {...billingFormMethods}>
          <BillingDataForm
            method="POST"
            onClose={onClose}
            onDocumentTypeChange={setDocumentType}
            withBillingDataSync
            hideLastName
          />
        </FormProvider>
      </Styles>
    </Modal>
  );
};

BillingFormModal.defaultProps = {};

export default BillingFormModal;
